import request from '@/utils/httpRequest'

export default class UnitPriceService {
  queryById(id) {
    return request({
      url: '/shye/base/shyeLeasingResourcesAppy/queryById',
      method: 'get',
      params: { id: id }
    })
  }
  
  startFlow (params) {
    return request({
      url: '/shye/base/shyeLeasingResourcesAppy/startFlow',
      method: 'post',
      data: params
    })
  }
}
